module.exports = __webpack_public_path__ + "img/icon-ywqn-banner-3.8531e8bc.png";